import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import InputText from "../../Input/InputText";
import "../../../../assets/style/modalStyle/addAccount.scss";
import { useDispatch, useSelector } from "react-redux";
import { accountSelector } from "../../../../services/selector/index.";
import LabelInput from "../../LabelInput";
import InputPassWord from "../../Input/InputPassWord";
import {
  changePassWord,
  setErr,
  setMsg,
  setOpenModalChangePassWord,
  setOpenPUEditAcc,
} from "../../../../services/slice/AccountSlice";
import { revertTypeAcc } from "../../../../utils/convertNumber";
import {
  containsWhitespace,
  isValidPass,
} from "../../../../utils/functionCommon";
import { resetNotifyMenu } from "../../../../services/slice/ConfigMenuSlice";

const ModalChangePassWord = () => {
  const stateUser = useSelector(accountSelector);
  const { msg } = stateUser;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const [data, setData] = useState({
    username: localStorage.getItem("userInfor"),
    oldPass: "",
    newPass: "",
    repeatPass: "",
  });
  useEffect(() => {
    if (stateUser.isError) {
      setError({
        isError: true,
        msg: stateUser.msg,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateUser.isError]);
  const handleCancel = () => {
    dispatch(resetNotifyMenu());
    dispatch(setOpenModalChangePassWord(false));
  };
  const handleSubmit = () => {
    if (!data.newPass) {
      setError({
        isError: true,
        msg: "Mật khẩu không được để trống",
      });
      return;
    }
    if (data.newPass !== data.repeatPass) {
      setError({
        isError: true,
        msg: "Mật khẩu không trùng khớp. Vui lòng nhập lại",
      });
      return;
    }
    if (data.newPass === data.oldPass) {
      setError({
        isError: true,
        msg: "Mật khẩu mới và mật khẩu cũ không được trùng",
      });
      return;
    }

    if (data.username.length < 5) {
      setError({
        isError: true,
        msg: "Tên tài khoản phải có độ dài tối thiểu 5 kí tự",
      });
      return;
    }

    if (containsWhitespace(data.newPass)) {
      setError({
        isError: true,
        msg: "Mật khẩu không được chứa khoảng trắng",
      });
      return;
    }
    if (data.newPass.length < 8) {
      setError({
        isError: true,
        msg: "Mật khẩu phải có độ dài từ 8 kí tự trở lên",
      });
      return;
    }
    if (!isValidPass(data.newPass)) {
      setError({
        isError: true,
        msg: "Mật khẩu phải chứa 4 kiểu ký tự (a-z, A-Z, 0-9, #?!@$%^&*-.)",
      });
      return;
    }
    if (stateUser.isError) return;
    setError({
      isError: false,
      msg: "",
    });
    dispatch(changePassWord(data));
  };

  return (
    <>
      <Modal
        maskClosable={false}
        style={{ position: "relative" }}
        title={t("Đổi mật khẩu")}
        centered
        width={570}
        className="warrperModalAddAcc"
        open={stateUser.isOpenModalChangePassWord}
        onCancel={handleCancel}
        footer={[
          <div className="evenSpace" style={{ marginTop: "1.5rem" }}>
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              width={155}
              content={"Đồng ý"}
              typeBtn="btnOrange"
              handleClick={handleSubmit}
            />
          </div>,
        ]}
      >
        <Row>
          <Col span={10}>
            <LabelInput text={"Tên tài khoản"} />
          </Col>
          <Col span={14}>
            <InputText
              maxLength={50}
              typeInput={"baseInput"}
              disable
              text={data.username}
              placeholder={"Nhập tên tài khoản"}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={10}>
            <LabelInput text={"Mật khẩu hiện tại"} />
          </Col>
          <Col span={14}>
            <InputPassWord
              typeInput={"baseInput"}
              password={data.oldPass}
              setPassWord={(value) => {
                dispatch(setErr({ isError: false, msg: "" }));
                setData({ ...data, oldPass: value });
              }}
              placeholder={"Nhập mật khẩu hiện tại"}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={10}>
            <LabelInput text={"Mật khẩu mới"} />
          </Col>
          <Col span={14}>
            <InputPassWord
              typeInput={"baseInput"}
              password={data.newPass}
              setPassWord={(value) => {
                setData({ ...data, newPass: value });
              }}
              placeholder={"Nhập mật khẩu mới"}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={10}>
            <LabelInput text={"Nhập lại mật khẩu mới"} />
          </Col>
          <Col span={14}>
            <InputPassWord
              typeInput={`baseInput ${
                !data.repeatPass ? "checkEmptyText" : null
              }`}
              password={data.repeatPass}
              setPassWord={(value) => setData({ ...data, repeatPass: value })}
              placeholder={"Nhập lại mật khẩu mật khẩu"}
            />
          </Col>
        </Row>

        {error.isError ? <small className="msg">{t(error.msg)}</small> : null}
      </Modal>
    </>
  );
};

export default ModalChangePassWord;
